import browserUpdate from 'browser-update';
import isChromatic from 'chromatic/isChromatic';
import { useEffect, useRef } from 'react';

/**
 * Display a banner to users with outdated browsers.
 * @see https://help.carrot.com/tutorial/supported-browsers/
 *
 * You can visit AMUI with `#test-bu` in the URL to force the banner to display
 */
export function BrowserUpdate() {
  const containerRef = useRef(null);

  useEffect(() => {
    if (containerRef.current && !isChromatic()) {
      browserUpdate({
        required: {
          e: -4,
          f: -4,
          o: -4,
          s: -1,
          c: -4,
        },
        insecure: true,
        api: 2024.04,
        reminder: 0,
        reminderClosed: 150,
        no_permanent_hide: true,
        shift_page_down: false,
        container: containerRef.current,
      });
    }
  }, []);

  return <div ref={containerRef}></div>;
}
